import { render, staticRenderFns } from "./settingsCreditCardAccounts.vue?vue&type=template&id=5edf46b4&scoped=true&"
import script from "./settingsCreditCardAccounts.vue?vue&type=script&lang=js&"
export * from "./settingsCreditCardAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf46b4",
  null
  
)

export default component.exports